module.exports = __webpack_public_path__ + "static/14-should-you-focus-on-finding-your-business-purpose-ee2ffe3bd762d96e10371786c9acf822.jpg";